import React from "react";
import PropTypes from "prop-types";
import SeasonRecordsPairTable from "./SeasonRecordsPairTable";

const SeasonPositionalRecordsTable = ({ bestPositionalStats, worstPositionalStats }) => (
    <SeasonRecordsPairTable bestStats={bestPositionalStats} worstStats={worstPositionalStats} loadingLabel="positional records" />
);

SeasonPositionalRecordsTable.propTypes = {
    bestPositionalStats: PropTypes.array,
    worstPositionalStats: PropTypes.array,
};

export default SeasonPositionalRecordsTable;
